import fetchApi from './fetch-api';

export default async function logout() {
  await fetchApi({
    method: 'POST',
    path: '/auth/logout'
  });
}
